import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { signOutUser } from "../../utils/firebase/firebase.utils";
import "./signOut.style.scss";
import Button from "../../components/button/button.comp";
import { UserContext } from "../../contexts/user.context";

const SignOut = () => {

    const navigate = useNavigate();
    const { setCurrentUser, setUserID, setProfileImageUrl } = useContext(UserContext); // Destructure context setters

    const handleSignOut = async () => {
        try {
            await signOutUser(); // Call the signOutUser function
            setCurrentUser(null); // Reset currentUser
            setUserID(null); // Reset userID
            setProfileImageUrl('https://static.vecteezy.com/system/resources/thumbnails/002/318/271/small_2x/user-profile-icon-free-vector.jpg'); // Reset profileImageUrl to default
            navigate('/'); // Navigate after sign out
        } catch (error) {
            // Handle any sign-out errors here
            console.error("Error signing out:", error.message);
        }
    };

    return (
        <div>
            <h3>Are you sure you want to sign out?</h3>
            <Button text={'sign out'} option={'yellow'} onClick={handleSignOut} />
        </div>
    );
};

export default SignOut;